import { render } from "./invoice-view.vue?vue&type=template&id=34b5d407"
import script from "./invoice-view.vue?vue&type=script&lang=js"
export * from "./invoice-view.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__